import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=afe19670"
import script from "./Backtop.vue?vue&type=script&lang=js"
export * from "./Backtop.vue?vue&type=script&lang=js"
import style0 from "../../theme/backtop.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports